module.exports = __webpack_public_path__ + "fonts/OpenSans-Semibold.33f225b.ttf";